import React from "react";
import ReactDOM from "react-dom";
import { Alert } from "@mui/material";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import { Routes } from "../../../root/routes";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { useHistory } from "react-router";

export const HR_CENTER_SETUP_BANNER_DISMISSED_COOKIE_NAME = "hr_center_setup_banner_dismissed";

const HRCenterSetupAlert = ({ alreadyInvitedHrUser }: { alreadyInvitedHrUser: boolean }) => {
  const history = useHistory();

  const [dismissedHrCenterSetupBanner, setDismissedHrCenterSetupBanner] = useLocalStorage(
    HR_CENTER_SETUP_BANNER_DISMISSED_COOKIE_NAME,
    "false",
  );

  if (dismissedHrCenterSetupBanner === "true") {
    return null;
  }

  return (
    <Alert
      severity="info"
      icon={false}
      sx={{
        // royal info recipe (POL-7778): fill blue-50, body text blue-800
        backgroundColor: "#EFF6FF",
        color: "#193CB8",
        fontWeight: 500,
        display: "block",
        padding: "0",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 24px",
        }}
      >
        <div style={{ display: "flex", gap: "12px", alignItems: "flex-end" }}>
          <div style={{ alignSelf: "flex-start", height: "24px" }}>
            <ExclamationCircleIcon style={{ width: "24px", height: "24px", color: "#155DFC" }} />
          </div>
          <div>
            {alreadyInvitedHrUser
              ? `You have invited an HR user to your organization. You can still complete the HR Center setup yourself, or wait for them to finish it.`
              : `You are currently configuring your HR Center. If you have an HR user in your organization, invite them to complete this setup.`}
          </div>
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          <div
            onClick={() => {
              setDismissedHrCenterSetupBanner("true");
            }}
            style={{
              background: "none",
              border: "1px solid #155DFC",
              borderRadius: "6px",
              // link/text control on the fill -> blue-700 (AA)
              color: "#1447E6",
              cursor: "pointer",
              fontWeight: 500,
              padding: "8px 17px",
            }}
          >
            Dismiss
          </div>
          {!alreadyInvitedHrUser && (
            <div
              onClick={() => {
                history.push(`${Routes.organization.settings.users}?invite_hr_user=true`);
              }}
              style={{
                background: "#155DFC",
                border: "none",
                borderRadius: "6px",
                color: "#F9F8FB",
                cursor: "pointer",
                fontWeight: 500,
                padding: "8px 17px",
              }}
            >
              Invite HR User
            </div>
          )}
        </div>
      </div>
    </Alert>
  );
};

export const HRCenterSetupBanner = ({
  alreadyInvitedHrUser,
}: {
  alreadyInvitedHrUser: boolean;
}) => {
  const mount = document.getElementById("top-banner");
  return ReactDOM.createPortal(
    <HRCenterSetupAlert alreadyInvitedHrUser={alreadyInvitedHrUser} />,
    mount,
  );
};
